import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgToiletAccessible = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M41.794 38.734A17.61 17.61 0 0 0 26.622 21.8v-1.637a8.732 8.732 0 1 0-5-.038V21.8A17.689 17.689 0 0 0 24.166 57h.034a17.63 17.63 0 0 0 16.714-12.144l9.157 8.917 3.489-3.582zM21.542 14.412a3.756 3.756 0 1 1 2.683 1.1h-.014a3.75 3.75 0 0 1-2.669-1.1m11.567 33.87A12.65 12.65 0 0 1 24.2 52h-.035a12.7 12.7 0 0 1-2.544-25.149v15.466h14.826a12.6 12.6 0 0 1-3.338 5.965m-6.487-10.965v-10.47a12.66 12.66 0 0 1 10.032 10.47z",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToiletAccessible);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
